import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lot-card"
}
const _hoisted_2 = { class: "lot-card-logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "lot-card-name" }
const _hoisted_5 = { class: "lot-card-info" }
const _hoisted_6 = { class: "lot-card-info-row" }
const _hoisted_7 = { class: "lot-card-info-row-value" }
const _hoisted_8 = { class: "lot-card-info-row" }
const _hoisted_9 = { class: "lot-card-info-row-value" }
const _hoisted_10 = { class: "lot-card-info-row" }
const _hoisted_11 = { class: "lot-card-info-row-value" }
const _hoisted_12 = { class: "lot-card-info-row" }
const _hoisted_13 = { class: "lot-card-info-row-value" }
const _hoisted_14 = { class: "lot-card-info-row" }
const _hoisted_15 = { class: "lot-card-info-row-value" }
const _hoisted_16 = { class: "lot-card-info-row" }
const _hoisted_17 = { class: "lot-card-info-row-value" }
const _hoisted_18 = {
  key: 0,
  class: "lot-card-info-row"
}
const _hoisted_19 = { class: "lot-card-info-row-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.lot)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: $setup.logoUrl,
            alt: "Estate logo"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("h1", _hoisted_4, "Lot " + _toDisplayString($props.lot.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "lot-card-info-row-title" }, "Stage", -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString($props.lot.stageId.title), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "lot-card-info-row-title" }, "Street Name", -1)),
            _createElementVNode("div", _hoisted_9, _toDisplayString($props.lot.streetName || "--"), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "lot-card-info-row-title" }, "Block Width", -1)),
            _createElementVNode("div", _hoisted_11, _toDisplayString($props.lot.blockWidth ? `${$setup.formatPrice($props.lot.blockWidth, false)} m` : "Irregular"), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "lot-card-info-row-title" }, "Block Depth", -1)),
            _createElementVNode("div", _hoisted_13, _toDisplayString($props.lot.blockDepth ? `${$setup.formatPrice($props.lot.blockDepth, false)} m` : "Irregular"), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "lot-card-info-row-title" }, "Size", -1)),
            _createElementVNode("div", _hoisted_15, _toDisplayString($setup.formatPrice($props.lot.size, false)) + " sqm", 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "lot-card-info-row-title" }, "Release Date", -1)),
            _createElementVNode("div", _hoisted_17, _toDisplayString($setup.getDate()), 1)
          ]),
          (!$props.estate.hidePrice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "lot-card-info-row-title" }, "Price", -1)),
                _createElementVNode("div", _hoisted_19, _toDisplayString($setup.formatPrice($props.lot.price)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}